import { landxmlLoadingAtom } from '@/atoms';
import { LoadingBadge } from '@/components/ui/LoadingBadge';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';

/**
 * Badge rows showing LandXML layers while they download and parse. One row per
 * layer; rows clear as soon as the layer's geometry reaches the scene, and a
 * failed load sticks around so the user can see why nothing appeared.
 *
 * Renders rows only — `ViewerLoadingColumn` positions and stacks it with the
 * other loaders.
 */
export const LandXMLLoadingOverlay = () => {
  const { t } = useTranslation('project');
  const loading = useAtomValue(landxmlLoadingAtom);
  const entries = Object.values(loading);
  if (entries.length === 0) return null;

  const labels = {
    fetching: t('landxmlLoader.fetching'),
    decoding: t('landxmlLoader.decoding'),
    failed: t('landxmlLoader.failed'),
  };

  return (
    <>
      {entries.map((e) => (
        <LoadingBadge
          key={e.layerId}
          name={e.layerName}
          phase={e.phase}
          progress={e.progress}
          loadedBytes={e.loadedBytes}
          totalBytes={e.totalBytes}
          error={e.error}
          labels={labels}
        />
      ))}
    </>
  );
};
